import { useReducer, useEffect } from "react";
import siteIdReducer from "./reducer";
import { fetchSiteIdBySerial } from "./api";
import ACTIONS from "./actions";
import { TEXT_LIBRARY } from "../utils/constants";
import SnackbarUtils from "../components/Snackbar/utils";

const initialState = {
  isLoading: false,
  isError: false,
  siteId: null,
};

async function getSiteId(dispatch, serialNumber) {
  dispatch({ type: ACTIONS.FETCH_SITE_ID_INIT });
  try {
    const res = await fetchSiteIdBySerial(serialNumber);
    const siteId = (Array.isArray(res?.data) && (res.data[0]?.siteId || res.data[0]?.systemId)) || null;
    if (siteId) {
      dispatch({ type: ACTIONS.FETCH_SITE_ID_SUCCESS, payload: siteId });
    } else {
      console.error("No active siteId found for", serialNumber);
      dispatch({ type: ACTIONS.FETCH_SITE_ID_FAILURE });
      SnackbarUtils.error(TEXT_LIBRARY.NO_ACTIVE_SITEID_FOUND);
    }
  } catch (err) {
    console.error("Error fetching siteId for serialNumber", serialNumber, err);
    dispatch({ type: ACTIONS.FETCH_SITE_ID_FAILURE });
    SnackbarUtils.error(TEXT_LIBRARY.ERROR_IN_FETCHING_SITEID);
  }
}

function useFetchSiteId(serialNumber, debounceMs = 500) {
  const [state, dispatch] = useReducer(siteIdReducer, initialState);

  useEffect(() => {
    const handler = setTimeout(() => {
      if (serialNumber) {
        getSiteId(dispatch, serialNumber);
      }
    }, debounceMs);

    return () => clearTimeout(handler);
  }, [serialNumber, debounceMs]);

  return {
    siteId: state.siteId,
    loading: state.isLoading,
    error: state.isError,
    dispatch,
  };
}

export default useFetchSiteId;
